import { PolymerElement } from '@polymer/polymer/polymer-element.js';
import template from './ns-content-accordion.html';
export class NsContentAccordion extends PolymerElement {
  ready() {
    super.ready();
    this.CLAMP_LIMIT = 200;
    this.activated = false;
    this.shouldClamp = this._shouldClamp();
    this.shown = this._getContent();
  }

  _onContentChange(newVal) {
    if (newVal) {
      this.set('content', newVal);
      this.activated = false;
      this.shouldClamp = this._shouldClamp();
      this.shown = this._getContent();
    }
  }

  _getContent() {
    if (!this.content) return;
    const [ shown, hidden ] = this._splitContent(this.content);
    if (this.activated) {
      return shown + hidden;
    } else if (this.shouldClamp) {
      return shown + '...';
    } else {
      return shown;
    }
  }

  _shouldClamp() {
    if (this.content && this.content.length >= this.CLAMP_LIMIT) {
      return true;
    }
    return false;
  }

  _splitContent(string) {
    if (!string) return [null, null];
    const shownContent = string.substring(0, this.CLAMP_LIMIT);
    const hiddenContent = string.substring(this.CLAMP_LIMIT);
    return [shownContent, hiddenContent];
  }

  _setClassName() {
    if (this.activated) {
      return this.className = 'closed';
    } else {
      return this.className = 'opened';
    }
  }

  static get template() {
    let htmlElement = document.createElement('TEMPLATE');
    htmlElement.innerHTML = template;
    return htmlElement;
  }

  _onClick() {
    this.className = this._setClassName();
    this.activated = !this.activated;
    this.shown = this._getContent();
  }

  _computeButton(isMobile){
    return isMobile ? 'ns-content-accordion mobile': 'ns-content-accordion'
  }
  static get properties() {
    return {
      content: {
        type: String, 
        value: '',
        observer: '_onContentChange'
      },
      shown: String,
      activated: Boolean,
      hidden: String,
      shouldClamp: Boolean,
      className: {
        type: String,
        value: 'closed'
      },
      isMobile: {
        type: Boolean,
        value: false
      },
      fadeTo: String
    }
  }

  static get is() {
    return 'ns-content-accordion';
  }
}

window.customElements.define(NsContentAccordion.is, NsContentAccordion);